export default __webpack_public_path__ + "static/media/Screenshot-weather.48f8fb5d.png";